import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishTimepicker } from './timepicker';
import { FishTimepickerConfig } from './timepicker-config';

export { FishTimepicker } from './timepicker';
export { FishTimepickerConfig } from './timepicker-config';
export { FishTimeStruct } from './fish-time-struct';


export class FishTimepickerModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishTimepickerModule, providers: [FishTimepickerConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishTimepicker],
  exports: [FishTimepicker],
  imports: [CommonModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
